/**
 * ChecklistSecoes — as cinco seções do prompt de especialista com ✅/⚠️, o contador
 * `chars/mínimo` e os motivos (A1 FR-2..FR-4). Recebe o resultado de `validarPrompt`
 * (calculado no cliente, em tempo real) ou o `validacao` que a API devolveu.
 */
import { C } from '@/theme/palette';
import { SECOES, ROTULO_DA_SECAO, TEXTO_DO_MOTIVO } from '@/lib/validarPrompt';

export function ChecklistSecoes({ validacao, titulo = 'Checklist do prompt de especialista' }) {
  if (!validacao || typeof validacao !== 'object' || !validacao.secoes) return null;
  const chars = Number(validacao.chars) || 0;
  const minimo = Number(validacao.minimo) || 0;
  const abaixo = minimo > 0 && chars < minimo;
  return (
    <div aria-label={titulo} role="group"
      style={{ padding: 12, borderRadius: 8, background: C.blackElev2, border: `1px solid ${C.blackBorder}` }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <span style={{ fontSize: 11, color: C.neutralMuted, letterSpacing: '0.05em', fontWeight: 600 }}>
          {titulo.toUpperCase()}
        </span>
        <span data-testid="contador-chars"
          style={{ marginLeft: 'auto', fontSize: 11.5, fontFamily: 'monospace', color: abaixo ? C.warn : C.cyber }}>
          {chars.toLocaleString('pt-BR')} / {minimo.toLocaleString('pt-BR')} caracteres
        </span>
      </div>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 4 }}>
        {SECOES.map((s) => {
          const ok = Boolean(validacao.secoes?.[s]);
          return (
            <li key={s} data-testid={`secao-${s}`}
              style={{ fontSize: 12.5, color: ok ? C.neutral : C.warn }}>
              {ok ? '✅' : '⚠️'} {ROTULO_DA_SECAO[s]}
            </li>
          );
        })}
      </ul>
      {(validacao.motivos || []).length > 0 && (
        <ul style={{ margin: '8px 0 0', paddingLeft: 18, fontSize: 12, color: C.warn }}>
          {validacao.motivos.map((m) => (
            <li key={m}>{TEXTO_DO_MOTIVO[m] ?? m}</li>
          ))}
        </ul>
      )}
      <div style={{ marginTop: 8, fontSize: 12, fontWeight: 600, color: validacao.ok ? C.cyber : C.warn }}>
        {validacao.ok ? '✅ prompt de especialista completo' : '⚠️ ainda não é prompt de especialista'}
      </div>
    </div>
  );
}
